'use strict';

/* global angular */

const _ = require('lodash');
const Errors = require('../common/Errors');

function AppService ($location, $rootScope, $state, AuthService, RoutingUtil, AnalyticsService, AppActions) {
  const getPageClass = () => {
    return pageClasses.join(' ');
  };

  const addPageClass = (classes) => {
    if (Array.isArray(classes)) {
      pageClasses = pageClasses.concat(classes);
    }
    else if (typeof classes === 'string') {
      pageClasses.push(classes);
    }
  };

  const resetPageClass = () => {
    return [];
  };

  let pageClasses = resetPageClass();

  _.extend(this, {
    getPageClass,
    addPageClass,
    resetPageClass
  });

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Event Handling
  /////////////////////////////////////////////////////////////////////////////////////////////////
  const onStateChangeError = (e, toState, toParams, fromState, fromParams, error) => {
    // console.log('%c -----> onStateChangeError', 'background-color:red;color:white;font-weight:bold;', e);
    const errorHandlers = {};

    errorHandlers[Errors.NOT_AUTHENTICATED] = RoutingUtil.redirectToLogin;
    errorHandlers[Errors.NOT_AUTHORIZED] = RoutingUtil.redirectTo404;
    errorHandlers[Errors.UNKNOWN_PAGE] = RoutingUtil.redirectTo404;

    // View errors thrown during $state transitions
    // @see https://github.com/angular-ui/ui-router/wiki - $stateChangeError
    if (error && errorHandlers[error]) {
      errorHandlers[error]();
    }
    else {
      console.log(toState, toParams, fromState, fromParams);
      console.error(error);
    }
  };

  const onStateChangeStart = (e, toState, toParams) => {
    // console.log('%c -----> onStateChangeStart!', 'background-color:green;color:white;font-weight:bold;', toState, toParams);
    // Save toState on every state change...
    // This is used by `AuthService` to check if the user is authorized to see the requested state
    $rootScope.toState = toState;
    $rootScope.toStateParams = toParams;
  };

  const onStateChangeSuccess = (e, toState, toParams, fromState, fromParams) => {
    // console.log('%c -----> onStateChangeSuccess!', 'background-color:green;color:white;font-weight:bold;', toState, toParams, fromState, fromParams);
    pageClasses = resetPageClass();

    // Set new body classes
    const absUrl = $location.absUrl();
    const loggedIn = AuthService.isAuthenticated();
    let search;
    // set top level url path as body class

    addPageClass($location.path().split('/'));
    if (loggedIn) {
      addPageClass('authenticated');
      AppActions.CheckCompleteSignIn.dispatch();
    }

    // extract any classes from $state data property
    if ($state.current.data) {
      addPageClass($state.current.data.classes);
    }

    if (absUrl.indexOf('?') !== -1) {
      search = absUrl.substring(absUrl.indexOf('?'), absUrl.length);
    }

    if (toState.name !== 'dash.map') {
      // killing the spinner at document ready was leading to the white screen on the map
      // but not turning it off at all leads it to show on other pages like settings
      // so just turn off the spinner for all non-map pages
      angular.element(document).find('body').addClass('-angular-ready');
    }

    AnalyticsService.page({  // Virtual Pageview
      title: document.title,
      search,
      url: absUrl,
      path: $location.path(),
      referrer: `${$location.protocol()}://${$location.host()}${$state.href(fromState, fromParams)}`
    });
  };

  $rootScope.$on('$stateChangeError', onStateChangeError);
  $rootScope.$on('$stateChangeStart', onStateChangeStart);
  $rootScope.$on('$stateChangeSuccess', onStateChangeSuccess);
}

AppService.$inject = [ '$location', '$rootScope', '$state', 'AuthService', 'RoutingUtil', 'AnalyticsService', 'AppActions'];

module.exports = AppService;



// WEBPACK FOOTER //
// ./src/app/AppService.js